module.exports = new __parcel__URL__("second_tab_content_en.74f6aca9.webp").toString();